import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class SearchIssueService {
  currentIssueSelectedFilter: Observable<string>;
  private textSearch = new BehaviorSubject<string>('');

  constructor() {
    this.currentIssueSelectedFilter = this.textSearch.asObservable();
  }

  changeOption(option: string) {
    this.textSearch.next(option);
  }
}
